<template>
  <div class="w-full h-full flex">
    <el-table
    ref="singleTable"
    border
    :data="listKeyAuthUser"
    highlight-current-row
    @current-change="selectKeyAuthUser"
    style="width: 100%">
      <el-table-column
        type="index"
        width="50">
      </el-table-column>
      <el-table-column
        property="app_name"
        label="App Name"
        width="300">
      </el-table-column>
      <el-table-column
        property="key"
        label="Key"
        width="100">
      </el-table-column>
      <el-table-column
        property="description"
        label="Description">
      </el-table-column>
      <el-table-column
        label="Revoked"
        width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.revoked">True</span>
          <span v-else>False</span>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="Detail key"
      :visible.sync="dialogVisible"
      width="30%">
      <el-form ref="form" :model="selectedKey" label-width="120px">
        <el-form-item label="App Name">
          <el-input v-model="selectedKey.app_name"></el-input>
        </el-form-item>

        <el-form-item label="Key">
          <el-input v-model="selectedKey.key"></el-input>
        </el-form-item>

        <el-form-item label="Description">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder=""
            v-model="selectedKey.description">
          </el-input>
        </el-form-item>

        <el-form-item label="Revoked">
          <el-radio-group v-model="selectedKey.revoked">
            <el-radio label="true"></el-radio>
            <el-radio label="false"></el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data: function () {
    return {
      dialogVisible: false,
      selectedKey: {
        app_name: '',
        key: '',
        description: '',
        revoked: false,
      },
    };
  },
  computed: {
    ...mapState({
      listKeyAuthUser: state => state.auth.listKeyAuthUser,
    }),
  },
  methods: {
    ...mapActions('auth', ['getListKeyAuthUser']),
    selectKeyAuthUser: function(key) {
      this.dialogVisible = true;
      this.selectedKey = key;
    }
  },
  created: function() {
    this.getListKeyAuthUser();
  }
}
</script>

<style>

</style>